<template>
    <section v-if="hasPermissions(['Budgeting-Staffing-Scenario Write'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1" v-html="title_page"/>
        <div class="view__description">
            <p class="view__description__text">
                Enter a Scenario name, FTE Hours, and any other information. Click Save.
            </p>
        </div>
        <form @submit.prevent="form_submit()">
            <div class="row m-0 formdynamic" :style="'padding-top:0px;'">
                <div class="py-0 formdynamic__item col-md-3">
                    <div class="formdynamic__item__field">
                        <label for="Scenario:" class="modal-label active">Scenario:  <b style="color:red;">*</b></label>
                        <input required type="text" v-model="form_data.scenario"/>
                    </div>
                </div>

                <div class="py-0 formdynamic__item col-md-3">
                    <div class="formdynamic__item__field">
                        <label for="FTE Hours:" class="modal-label active">FTE Hours: <b style="color:red;">*</b></label>
                        <input step="any" required type="number" v-model="form_data.fte_hours"/>
                    </div>
                </div>
                        
                <div class="py-0 formdynamic__item col-md-3">
                    <div class="formdynamic__item__field">
                        <label for="Budgeted FTEs" class="modal-label active">Budgeted FTEs</label>
                        <input step="any" type="number" v-model="form_data.budgeted_ftes"/>
                    </div>
                </div>

                <div class="py-0 formdynamic__item col-md-3">
                    <div class="formdynamic__item__field">
                        <label for="Created On:" class="modal-label active">Created  On: <b style="color:red;">*</b></label>
                        <input disabled required type="date" v-model="form_data.date"/>
                    </div>
                </div>
                        
                <div class="py-0 formdynamic__item col-md-3">
                    <div class="formdynamic__item__field">
                        <label for="Benefits (%)" class="modal-label active">Benefits (%)  <b style="color:red;">*</b></label>
                        <input step="any" required type="number" v-model="form_data.benefits"/>
                    </div>
                </div>
                
                <div class="py-0 formdynamic__item col-md-3">
                    <div class="formdynamic__item__field">
                        <label for="Nonproductive (%)" class="modal-label active">Nonproductive (%) </label>
                        <input step="any" type="number" v-model="form_data.nonproductive"/>
                    </div>
                </div>

                <div class="py-0 formdynamic__item col-md-3">
                    <div class="formdynamic__item__field">
                        <label for="Last Modified" class="modal-label active">Last Modified </label>
                        <input disabled maxlength="any" max="any" type="date" v-model="form_data.updated_date"/>
                    </div>
                </div>
                        
                <div class="py-0 formdynamic__item col-md-3">
                    <div class="formdynamic__item__field">
                        <label for="Paid Break Minutes" class="modal-label active">Paid Break Minutes </label>
                        <input step="any" type="number" v-model="form_data.paid_break_minutes"/>
                    </div>
                </div>
                        
                <div class="py-0 formdynamic__item col-md-3">
                    <div class="formdynamic__item__field">
                        <label for="Management Team" class="modal-label active">Management Team </label>
                        <input step="any" type="number" v-model="form_data.management_team"/>
                    </div>
                </div>
                        
                <div class="py-0 formdynamic__item col-md-3">
                    <div class="formdynamic__item__field">
                        <label for="Average Wage" class="modal-label active">Average Wage </label>
                        <input step="any" type="number" v-model="form_data.average_wage"/>
                    </div>
                </div>
                        
                <div class="py-0 formdynamic__item col-md-3">
                    <div class="formdynamic__item__field">
                        <label for="Total Salary Compensation" class="modal-label active">Total Salary Compensation </label>
                        <input disabled step="any" type="text" v-model="form_data.total_salary"/>
                    </div>
                </div>
                <div class="py-0 col-md-3"></div> <!-- Permitet correcta alineación de lo súltimos tres elementos de la cuadrícula -->
            </div>

           <DischargesForm :single_object="form_data"/>

            <div class="row mb-0 mt-3">
                <div class="col-md-8">
                    <div class="card cardModuleM pb-md-0">
                        <div class="card-content pb-md-0">
                            <div class="card-title">
                                <h2 class="subtitle--1" v-html="'Note'"/>
                            </div>
                            <textarea v-model="form_data.notes" rows="5" class="mt-3 card-content__text"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal__buttons d-md-flex justify-content-md-end">
                <button type="button" class="modal__buttons__item cancel ml-3 mr-0" style="margin-top:0px;" data-dismiss="modal" aria-label="Close" v-html="'Cancel'" @click="cancel()"/>
                <button class="modal__buttons__item" v-html="`Save <img class='ml-2' width='15px' src='/assets/img/svg/add-w.svg' alt=''/>`"/>
            </div>
        </form>
        <WaitingModal/>
    </section>
    <section v-else class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            you do not have permission for this section. contact your system administrator
        </h1>
    </section>
</template>

<script>
import axios            from    'axios';
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal     from    '@/components/WaitingModal'
import DischargesForm   from './DischargesForm';
import Resources        from    './resources'
import FormResources    from    './form_resources'
import 'vuetify/dist/vuetify.min.css'

import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});
export default {
    name: 'StaffingScenariosV2Create',

    components: {
        Breadcrumb,
        WaitingModal,
        DischargesForm
    },

    data() {
        return {
            notyf,
            axios,
            user:               this.get_user(),
            title_page:         'New Staffing Scenario',
            rest_api:           `staffing_scenarios`,
            table_headers:      Resources.table_headers,
            breadcrumb:         Resources.breadcrumb,
            add_btn:            'Add Staffing Scenario',
            single_select:      false,
            table_selection:    [],
            search:             '',
            global_index:       '',
            single_object:      {},
            array_options:      {},
            date:               '',
            form_data:          FormResources.form_data,
            form_backup:        {...FormResources.form_data},
            scenario_id:        this.$route.params.id,
        }
    },

    methods: {

        cancel()
        {
            window.location.href="/budgeting-staffing-scenario"
        },
    },
    watch: 
    {
        async 'form_data.benefits' (val) {
            this.form_data.total_salary = this.numberStringFormat(((this.form_data.fte_hours * 52) * ((val / 100) + 1)) * this.form_data.average_wage, 1)
        },

        async 'form_data.fte_hours' (val) {
            this.form_data.total_salary = this.numberStringFormat(((val * 52) * ((this.form_data.benefits / 100) + 1)) * this.form_data.average_wage, 1)
        },

        async 'form_data.average_wage' (val) {
            this.form_data.total_salary = this.numberStringFormat(((this.form_data.fte_hours * 52) * ((this.form_data.benefits / 100) + 1)) * val, 1)
        }

    },

    async mounted(){

        this.$on('unshiftObject', ()=> {
            setTimeout( ()=> {
                window.location.href='/budgeting-staffing-scenario'
            },1000);
        });

        if(this.hasPermissions(['Budgeting-Staffing-Scenario Write']))
        {
            this.form_data.date =  this.form_data.updated_date = new Date().toISOString().split('T')[0];
        }
        else
        {
            window.location.href = '/'
        }

    }
}
</script>
